export const dashboardLink = process.env.REACT_APP_LINK || 'http://localhost:3000/register';
